'use es6';

import { getSenderType } from './commonMessageFormatGetters';
export const getCommonMessageSenderType = ({
  message
}) => {
  return getSenderType(message);
};